export function showMoreContent() {
	const showMoreButtons = document.querySelectorAll('.show-more-button');

	if (showMoreButtons.length > 0) {
		let isClicked = true;
		showMoreButtons.forEach(button => {
			button.addEventListener('click', (e) => {
				if (isClicked) {
					e.target.textContent = 'Read less';
					isClicked = false;
				} else {
					e.target.textContent = 'Read more';
					isClicked = true;
				}
				e.target.nextElementSibling.classList.toggle('show-content');
			});
		})
	}
}